import firebaseApp from 'firebase/app';
import 'firebase/database';

const Connector = () => {
    function getConnection() {
        if(firebaseApp.apps.length === 0){
            const firebaseConfig = {
                apiKey: process.env.REACT_APP_apiKey,
                authDomain: process.env.REACT_APP_authDomain,
                databaseURL: process.env.REACT_APP_databaseURL,
                projectId: process.env.REACT_APP_projectId,
                storageBucket: process.env.REACT_APP_storageBucket,
                messagingSenderId: process.env.REACT_APP_messagingSenderId,
                appId: process.env.REACT_APP_appId
            };
            firebaseApp.initializeApp(firebaseConfig);
        }

        return firebaseApp.database();
    }
    return {
        getConnection
    }
}

export default Connector()